import * as React from 'react'

const SvgStepIcon1Icon = (props) => (
  <svg
    width="49"
    height="49"
    viewBox="0 0 49 49"
    className="-ml-2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3936_99770)">
      <g clipPath="url(#clip0_3936_99770)">
        <rect
          x="4.44336"
          y="4.58301"
          width="40"
          height="40"
          rx="20"
          fill="#EEF4FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9374 16.8998L21.004 28.4164L17.8373 25.0331C17.254 24.4831 16.3373 24.4498 15.6707 24.9164C15.0207 25.3998 14.8373 26.2498 15.2373 26.9331L18.9873 33.0331C19.354 33.5998 19.9873 33.9498 20.704 33.9498C21.3873 33.9498 22.0373 33.5998 22.404 33.0331C23.004 32.2498 34.454 18.5998 34.454 18.5998C35.954 17.0664 34.1374 15.7164 32.9374 16.8831V16.8998Z"
          fill="#444CE7"
        />
        <rect
          x="5.44336"
          y="5.58301"
          width="38"
          height="38"
          rx="19"
          stroke="#444CE7"
          strokeWidth="2"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_3936_99770"
        x="0.443359"
        y="0.583008"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3936_99770"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.266667 0 0 0 0 0.298039 0 0 0 0 0.905882 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3936_99770"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3936_99770"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_3936_99770">
        <rect
          x="4.44336"
          y="4.58301"
          width="40"
          height="40"
          rx="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgStepIcon1Icon
